export const MYPAGE_MENU_BASIC = 'mypage.page.menu.basic';
export const MYPAGE_MENU_COMPANY = 'mypage.page.menu.company';
export const MYPAGE_MENU_EDUCATION = 'mypage.page.menu.education';
export const MYPAGE_MENU_ENROLLMENT = 'mypage.page.menu.enrollment';
export const MYPAGE_MENU_PASSWORD = 'mypage.page.menu.password';
export const MYPAGE_MENU_SERVICE_TERMS = 'mypage.page.menu.serviceTerms';
export const MYPAGE_MENU_PRIVACY_TERMS = 'mypage.page.menu.privacyTerms';
export const MYPAGE_MENU_ACCOUNT_EXIT = 'mypage.page.menu.accountExit';

export const MYPAGE_RAW_EMAIL_DIRECT_INPUT = '직접입력';
export const MYPAGE_RAW_GENDER_MALE = '남';
export const MYPAGE_RAW_GENDER_FEMALE = '여';
export const MYPAGE_RAW_COUNTRY_KOREA = '대한민국';
export const MYPAGE_RAW_POSITION_DIRECT_INPUT = '기타(직접입력)';
export const MYPAGE_RAW_CERT_STATUS_FAILED = '인증 실패';
export const MYPAGE_RAW_CERT_STATUS_FALSE = 'false';

export const mypageMenuList = [
	{ menu: MYPAGE_MENU_BASIC, path: '/mypage/basic' },
	{ menu: MYPAGE_MENU_COMPANY, path: '/mypage/company' },
	{ menu: MYPAGE_MENU_EDUCATION, path: '/mypage/education' },
	// { menu: MYPAGE_MENU_ENROLLMENT, path: '/mypage/enrollment' },
	{ menu: MYPAGE_MENU_PASSWORD, path: '/mypage/password' },
	{ menu: MYPAGE_MENU_SERVICE_TERMS, path: '/mypage/term/service' },
	{ menu: MYPAGE_MENU_PRIVACY_TERMS, path: '/mypage/term/privacy' },
] as const;

const LEGACY_MYPAGE_MENU_MAP: Record<string, string> = {
	기본정보: MYPAGE_MENU_BASIC,
	직장정보: MYPAGE_MENU_COMPANY,
	학력정보: MYPAGE_MENU_EDUCATION,
	재학인증: MYPAGE_MENU_ENROLLMENT,
	'비밀번호 변경': MYPAGE_MENU_PASSWORD,
	'서비스 이용약관': MYPAGE_MENU_SERVICE_TERMS,
	'개인정보 처리방침': MYPAGE_MENU_PRIVACY_TERMS,
	회원탈퇴: MYPAGE_MENU_ACCOUNT_EXIT,
};

export const normalizeMypageMenu = (value?: string | null) => {
	if (!value) {
		return MYPAGE_MENU_BASIC;
	}

	if (
		Object.values({
			MYPAGE_MENU_BASIC,
			MYPAGE_MENU_COMPANY,
			MYPAGE_MENU_EDUCATION,
			MYPAGE_MENU_ENROLLMENT,
			MYPAGE_MENU_PASSWORD,
			MYPAGE_MENU_SERVICE_TERMS,
			MYPAGE_MENU_PRIVACY_TERMS,
			MYPAGE_MENU_ACCOUNT_EXIT,
		}).includes(value as never)
	) {
		return value;
	}

	return LEGACY_MYPAGE_MENU_MAP[value] ?? MYPAGE_MENU_BASIC;
};
